const getFromLocalStorage = (itemName) => {
  return window.localStorage.getItem(itemName)
}

export default getFromLocalStorage
